// extracted by mini-css-extract-plugin
module.exports = {"consultant-details":"ConsultantDetails_consultant-details__cYXhI","consultant-details__avatar":"ConsultantDetails_consultant-details__avatar__WZpvX"};